export class AppSettings {
    public static API_ENDPOINT_MA = 'https://macro-ma-cloud.macrosistemasapp.com/';
    // public static API_ENDPOINT_MA = 'http://macroma.us-east-2.elasticbeanstalk.com:8080/';
    public static API_ENDPOINT_USER = 'https://macro-user.macrosistemasapp.com/api/';
    public static API_ENDPOINT_REPORTS = 'https://macro-report.macrosistemasapp.com/';
    // public static API_ENDPOINT_USER = 'http://localhost:8080/api/';
    // public static API_ENDPOINT_MA = 'http://localhost:8090/';
    // public static API_ENDPOINT_REPORTS = 'http://localhost:8091/';
    public static API_ENDPOINT_MA_ITEM = 'https://macro-ma-cloud.macrosistemasapp.com/';//'https://macro-ma-cloud.macrosistemasapp.com/';
    public static API_ENDPOINT_MA_FORMULARIOS = 'https://macro-ma-cloud.macrosistemasapp.com/';
}



// WEBPACK FOOTER //
// ./src/app/shared/config/app.settings.ts